<template>
    <div class="item_sidebar shadow-prop" :class="{'active': moreFields}">
	    <div class="wrapper_title" style="margin-bottom: 15px;">
		    <div class="title">{{ title }}</div>

            <div class="wrapper_title_right">
                <a class="small-btn sidebar_item_plus" @click="addNewShadow">
	                <svg width="15" height="16" viewBox="0 0 15 16" fill="none" >
		                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.125 7.375H13.75V8.625H8.125V14.25H6.875V8.625H1.25V7.375H6.875V1.75H8.125V7.375Z" fill="#97AACD"/>
	                </svg>
	                <!--                    <img src="@/modules/page-editor/src/assets/img/plus-icon.svg" alt="">-->
                </a>
                <a class="sidebar_item_open_arrow" :class="{'active':moreFields}" @click="moreFieldsToggle">
	                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" >
		                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3333 14.4341L17.5117 13.2557L10.2558 5.99991L3 13.2557L4.17833 14.4341L10.2558 8.35658L16.3333 14.4341Z" fill="#4368E0" fill-opacity="0.6"/>
	                </svg>
                </a>
            </div>
	    </div>
        <div class="wrapper_body wrapper_body_block" style="width: calc(100% + 30px);margin-left: -15px;">
            <div class="shadow_item" v-for="(item, index) in shadowsData" :key="index">
                <a class="minus_btn" @click="removeShadow(index)">
                    <img src="@/modules/page-editor/src/assets/img/minus-icon.svg" alt="">
                </a>
                <span class="shadow_type_name">{{ item.type === '' ? 'Drop Shadow' : 'Inner Shadow'}}</span>
                <a class="settings_btn" @click="openShadowSettings($event, index)">
	                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" >
		                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9159 12.4531L12.4378 13.9312L10.5459 13.4042L10.0048 13.6273L9.03355 15.3325H6.94384L5.97795 13.6215L5.43744 13.3949L3.54572 13.9154L2.0683 12.438L2.59534 10.5461L2.37215 10.0049L0.666992 9.03292V6.94327L2.37871 5.9774L2.60531 5.43695L2.08479 3.54523L3.56165 2.06838L5.45356 2.59615L5.99414 2.3732L6.96395 0.666504H9.0542L10.0201 2.37822L10.5605 2.60482L12.4519 2.08439L13.9311 3.56141L13.404 5.45362L13.627 5.99432L15.3337 6.96414V9.05439L13.6221 10.0202L13.3953 10.5618L13.9159 12.4531ZM11.9876 10.4717L12.5688 9.08358L14.0003 8.27579V7.74005L12.5693 6.92687L11.9964 5.53781L12.4375 3.95428L12.0583 3.57559L10.4699 4.01263L9.0833 3.43124L8.27561 1.99984H7.73986L6.92669 3.43087L5.5375 4.0038L3.95367 3.56198L3.57616 3.93948L4.01312 5.52754L3.43172 6.91417L2.00033 7.72186V8.25821L3.4302 9.07326L4.00289 10.4619L3.56168 12.0457L3.93997 12.424L5.52803 11.987L6.9146 12.5684L7.72227 13.9992H8.25855L9.07296 12.5693L10.4617 11.9966L12.0455 12.4378L12.4245 12.0589L11.9876 10.4717ZM8.00032 10.6665C6.52757 10.6665 5.33366 9.4726 5.33366 7.99984C5.33366 6.52708 6.52757 5.33317 8.00032 5.33317C9.47308 5.33317 10.667 6.52708 10.667 7.99984C10.667 9.4726 9.47308 10.6665 8.00032 10.6665ZM8.00032 9.33317C8.7367 9.33317 9.33366 8.73622 9.33366 7.99984C9.33366 7.26346 8.7367 6.6665 8.00032 6.6665C7.26394 6.6665 6.66699 7.26346 6.66699 7.99984C6.66699 8.73622 7.26394 9.33317 8.00032 9.33317Z" fill="#4368E0" fill-opacity="0.6"/>
	                </svg>
	                <!--                    <img src="@/modules/page-editor/src/assets/img/sidebar_item_settings_icon.svg" alt="">-->
                </a>
            </div>
            <div class="shadow_settings_window" v-if="shadowSettingsOpen" v-click-outside="windowClickOutside">
                <div class="window_header">
                    <span class="title">Shadow settings</span>
                    <a class="close_window_btn" @click="closeShadowSettings">
                        <img src="@/modules/page-editor/src/assets/img/cross-icon.svg" alt="">
                    </a>
                </div>
                <div class="window_body">
                    <div class="item items_row">
                        <div class="field margin_top_side w_100">
                          <div class="title">Angle</div>

                            <angle-selector :angle='value[selectedShadowIndex].angle||0' @change="updatedData($event, 'angle')" />

	                        <div class="flex"></div>
                            <input-field min="0" max="360" step="10" v-model.number="value[selectedShadowIndex].angle"
                            @change="updatedData($event, 'angle')" append="°" small type="number" />
                        </div>
                    </div>
                    <div class="item items_row">
                        <div class="field margin_top_side w_100">
                          <div class="title flex">Distance</div>
                            <input-field min="0" max="500" step="1" v-model.number="value[selectedShadowIndex].distance"
                            @change="updatedData($event, 'distance')" append="px" small type="number" />
                        </div>
                    </div>
                    <div class="item items_row" v-if="title !== 'Text shadow'">
                        <div class="field margin_top_side w_100">
                            <div class="title flex">Size</div>
                            <input-field min="0" max="500" step="1" v-model.number="value[selectedShadowIndex].spread"
                            @change="updatedData($event, 'spread')" append="px" small type="number" />
                        </div>
                    </div>
                    <div class="item items_row">
                        <div class="field margin_top_side w_100">
                            <div class="title flex">Blur</div>
                            <input-field min="0" max="500" step="1" v-model.number="value[selectedShadowIndex].blur"
                            @change="updatedData($event, 'blur')" append="px" small type="number" />
                        </div>
                    </div>
                    <colorPicker :value="value[selectedShadowIndex].color" title="Color" replacedClass="item items_row" @updated="updatedData($event, 'color')" />
                    <div class="item items_row" v-if="title !== 'Text shadow'">
                        <div class="title">Type</div>
                        <form action="#" class="radio_form radio_form_no_m_b">
                            <div class="item">
                                <input type="radio" id="test3" name="radio-group_2" value="" v-model="value[selectedShadowIndex].type" @change="updatedData($event.target.value, 'type')">
                                <label for="test3">Outer</label>
                            </div>
                            <div class="item">
                                <input type="radio" id="test4" name="radio-group_2" value="inset" v-model="value[selectedShadowIndex].type" @change="updatedData($event.target.value, 'type')">
                                <label for="test4">Inner</label>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import colorPicker from "@/modules/page-editor/src/components/sidebar/sidebar-items/colorPicker.vue"

import InputField from '@/components/base/input-field';
import AngleSelector from '../../base/angle-selector'

export default {
    name: 'ShadowsInput',
    components: {
        colorPicker,
	    InputField,
	    AngleSelector
    },
    props: ['title', 'value'],
    data: function(){
        return {
            shadowSettingsOpen: false,
            shadowSettingsTop: 0,
            selectedShadowIndex: 0,
	        moreFields: true,
	        shadowsData: [
				// {
                // angle: 0,
                // distance: 0,
                // blur: 0,
                // spread: 0,
                // color: 'transparent',
                // type: ''
            	// }
			],
        }
    },
    methods: {
        openShadowSettings(e, index){
            this.selectedShadowIndex = index;
            this.shadowSettingsOpen = true;
        },
        closeShadowSettings(){
            this.shadowSettingsOpen = false;
            this.selectedShadowIndex = 0;
        },
        moreFieldsToggle(){
            this.moreFields = !this.moreFields;

            localStorage.setItem(this.title, this.moreFields);
        },
        updatedData(val, fieldName){
			if(this.shadowsData.length) {
				if((fieldName == 'angle') || (fieldName == 'distance') || (fieldName == 'blur') || (fieldName == 'spread')) {
					this.shadowsData[this.selectedShadowIndex][fieldName] = +val;
				} else {
					this.shadowsData[this.selectedShadowIndex][fieldName] = val;
				}

				if(this.shadowsData[this.selectedShadowIndex].blur < 0) this.shadowsData[this.selectedShadowIndex].blur = 0;
				if(this.shadowsData[this.selectedShadowIndex].spread < 0) this.shadowsData[this.selectedShadowIndex].spread = 0;
			}

            this.$emit('updated', this.shadowsData);
        },
        numberMinus(name){
            this.shadowsData[this.selectedShadowIndex][name] -= 1;
            this.updatedData();
        },
        numberPlus(name){
            this.shadowsData[this.selectedShadowIndex][name] += 1;
            this.updatedData();
        },
        addNewShadow(){
            this.shadowsData.push({
                angle: 0,
                distance: 0,
                blur: 0,
                spread: 0,
                color: 'transparent',
                type: ''
            })
						this.updatedData();
            if (!this.moreFields) this.moreFieldsToggle();
        },
        removeShadow(index){
            this.shadowsData.splice(index, 1);
            this.updatedData();
        },
        windowClickOutside(e){
            if(!e.target.classList.contains('settings_btn') && !e.target.closest('.settings_btn')){
                this.closeShadowSettings();
            }
        }
    },
    created(){
      	this.shadowsData = JSON.parse(JSON.stringify(this.value));

	    if (this.shadowsData.color && this.shadowsData.color!=='transparent' && this.shadowsData.color!=='#00000000' ) {
		    this.moreFields = true;
	    }
    },
    mounted(){
        if(localStorage.getItem(this.title) !== null) {
            if(localStorage.getItem(this.title) === 'true') {
                this.moreFields = true;
            } else {
                this.moreFields = false;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.title {
	font-weight: 600;
}
</style>
